export enum DomCallRevealButtonEvent {
  reveal = 'reveal',
}
